module.exports = "/assets/ad764220d440de5ea838c7ff72e461cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/7M.png
// module id = 2246
// module chunks = 0